<template>
  <div v-if="visible" class="trip-record__status-message">
    <i class="bx bxs-info-circle message__error-icon"/>
    <span>
      {{ message }}
    </span>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue'

export default defineComponent({
  name: 'TripRecordStatusMessageComponent',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    message: {
      type: String,
      required: false
    }
  },
  emits: [],
  methods: {},
  components: {},
  setup() {
    return {}
  }
})
</script>

<style scoped>
.message__error-icon {
  margin-right: 5px;
  color: #d31515
}

.trip-record__status-message {
  border-radius: 0.25rem;
  padding: 20px;
  background: rgba(204, 204, 204, 0.1);
  margin-bottom: 2rem;
}
</style>
